import { Box, Stack, Typography, useTheme } from "@mui/material";

import { IVehicle } from "@app/modules/wishlist/type";
import { ToggleWishlist } from "./toggleWishlist";

interface VehicleInfoProps {
  name: string;
  category?: string;
  vehicle?: any;
}

const VehicleInfo = ({ name, category, vehicle }: VehicleInfoProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        px: 0.2,
        pt: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        position: "relative",
      }}
    >
      <Stack gap={category && 0.5}>
        <Typography
          variant="h6"
          fontSize={{ xs: 16, sm: 18 }}
          fontWeight="600"
          sx={{ color: theme.palette.common.black }}
        >
          {name}
        </Typography>
        <Typography
          fontSize={{ xs: 12, sm: 14 }}
          sx={{ color: theme.palette.common.black, fontWeight: "400" }}
        >
          {category}
        </Typography>
      </Stack>
      <Stack
        sx={{
          position: "absolute",
          right: 0,
        }}
      >
        <ToggleWishlist vehicle={vehicle} />
      </Stack>
    </Box>
  );
};

export { VehicleInfo };
